import React, { memo } from 'react';
import Div from '@/shared/Div';
import ImageWithFallback from '@/globalComponents/image';
import KotakBankIcon from 'public/images/kotak-bank-icon.png';
import HdfcBankIcon from 'public/images/hdfc-bank-icon.svg';
import RblBankIcon from 'public/images/rbl-bank-image.png';

const OfferCardIcons = (props: any) => {
  return (
    <Div className="flex relative">
      <Div className="w-8 h-8 rounded-cxs border border-solid border-co-subtle bg-cs-primary flex items-center justify-center p-[6px] relative">
        <ImageWithFallback width={32} height={32} src={HdfcBankIcon} alt="hdfc bank icon" />
      </Div>
      <Div className="w-8 h-8 rounded-cxs border border-solid border-co-subtle bg-cs-primary flex items-center justify-center p-[6px] absolute left-6">
        <ImageWithFallback width={32} height={32} src={RblBankIcon} alt="icici bank icon" />
      </Div>
      <Div className="w-8 h-8 rounded-cxs border border-solid border-co-subtle bg-cs-primary flex items-center justify-center p-1 absolute left-12">
        <ImageWithFallback width={32} height={32} src={KotakBankIcon} alt="kotak bank icon" />
      </Div>
    </Div>
  );
};

export default memo(OfferCardIcons);
